import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      beforeEnter () {
        window.location = 'https://signable.co.uk'
      }
    },
    {
      path: '/widget/:widgetCode',
      name: 'IndexWidget',
      component: Index
    },
    {
      path: '/preview/:previewURL',
      name: 'IndexPreview',
      component: Index
    },
    {
      path: '/:envelopeFingerprint/:signatureFingerprint',
      name: 'Index',
      component: Index
    }
  ]
})
